<template>
  <section class="why sec sec-tint">
    <div class="page">
      <div class="why-layout">
        <div class="why-left">
          <SectionHeading
            eyebrow="Why Hoyotech"
            title="为什么选择皓辰"
            :desc="'我们不做概念的搬运工。方案从地块与产线出发，' + '以能跑起来的系统和现场数据作为交付标准。'"
          />
          <router-link to="/about" class="btn btn-ghost why-btn">
            了解皓辰
            <IconSvg name="arrow-right"/>
          </router-link>
        </div>

        <div class="why-right">
          <div
            v-for="(w, i) in whyUs"
            :key="w.title"
            class="why-item reveal"
            v-reveal="{ delay: i * 90 }"
          >
            <div class="why-icon"><IconSvg :name="w.icon"/></div>
            <div class="why-body">
              <h3>{{ w.title }}</h3>
              <p>{{ w.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHeading from '@/components/common/SectionHeading'
import IconSvg from '@/components/common/IconSvg'
import { whyUs } from '@/data/site'

export default {
  name: 'WhySection',
  components: { SectionHeading, IconSvg },
  data() {
    return { whyUs }
  }
}
</script>

<style lang="scss" scoped>
.why-layout {
  display: grid;
  grid-template-columns: 0.85fr 1.15fr;
  gap: 60px;
  align-items: start;
}

.why-btn { margin-top: 4px; }

.why-right { display: flex; flex-direction: column; gap: 16px; }

.why-item {
  display: flex;
  gap: 18px;
  padding: 24px 26px;
  border-radius: 16px;
  border: 1px solid var(--line);
  background: linear-gradient(120deg, rgba(11, 23, 48, 0.6), rgba(5, 12, 27, 0.5));
  transition: transform 0.45s, border-color 0.45s, box-shadow 0.45s;

  &:hover {
    transform: translateX(6px);
    border-color: var(--line-strong);
    box-shadow: -18px 0 40px -30px rgba(34, 224, 255, 0.9);
  }

  &:hover .why-icon { color: var(--cyan); border-color: var(--cyan); }
}

.why-icon {
  width: 46px;
  height: 46px;
  padding: 12px;
  flex-shrink: 0;
  border-radius: 12px;
  border: 1px solid var(--line-strong);
  color: var(--txt-2);
  background: rgba(255, 255, 255, 0.03);
  transition: all 0.4s;
}

.why-body {
  h3 { font-size: 17.5px; color: #fff; }
  p { margin-top: 8px; font-size: 14px; line-height: 1.85; color: var(--txt-3); }
}

@media (max-width: 980px) {
  .why-layout { grid-template-columns: minmax(0, 1fr); gap: 28px; }
}

@media (max-width: 640px) {
  .why-item { padding: 20px 18px; gap: 14px; }
  .why-icon { width: 40px; height: 40px; padding: 10px; }
}
</style>
